import { apiClientJSON } from "../apiClient";

export interface AnalyticsDashboard {
  dashboardId: number;
  dashboardName: string;
  embedUrl: string;
  whitelabelId: number;
}

export interface AnalyticsDashboardConfig {
  dashboard: AnalyticsDashboard | null;
  metabaseUrl: string;
}

export const getAnalyticsDashboardConfig = async (
  whitelabelId?: number
): Promise<AnalyticsDashboardConfig> => {
  const params = whitelabelId ? `?whitelabel_id=${whitelabelId}` : "";
  const response = await apiClientJSON.get(
    `/backend/api/v1/admin/analytics/dashboard-config${params}`
  );

  const body = response.data.body;
  return {
    dashboard: body.dashboard
      ? {
          dashboardId: body.dashboard.dashboard_id,
          dashboardName: body.dashboard.dashboard_name,
          embedUrl: body.dashboard.embed_url,
          whitelabelId: body.dashboard.whitelabel_id,
        }
      : null,
    metabaseUrl: body.metabase_url,
  };
};
